module.exports = __webpack_public_path__ + "static/media/overview.63ccbb14.jpg";